
export interface LabelFontFamilyPickerProps {
    font: string;
    onChange: (font: string) => void;
}

export const LabelFontFamilyPicker = (props: LabelFontFamilyPickerProps) => {
    const fonts = [
        "Bodoni Moda",
        "Poppins",
        "Montserrat",
        "Spectral",
        "Roboto",
        "Roboto Slab",
        "Yanone Kaffeesatz",
        "Noto Sans",

        "Abril Fatface",
        "Bitter",
        "Anton",
        "Lato",
        "Rochester",
        "Open Sans",
        "Raleway",
        "Style Script",
        "Water Brush",

        "Caveat Brush",
        "Shadows Into Light",
        "Satisfy",
        "Caprasimo",
        "Permanent Marker",
    ]

    return <div>
        <select className="py-3 px-3 w-full rounded border border-gray-1 outline-0"
            value={props.font}
            onChange={e=>props.onChange(e.target.value)}
        >
            {fonts.map((font, i) => {
                return <option value={font} key={i}>
                    {font}
                </option>
            })}
        </select>
    </div>
}
